// AuthContext.tsx
import React, { createContext, useState, useEffect } from 'react';
import { identifyUser } from '../../services/analytics';
import { setMonitoringUser } from '../../services/monitoring';

interface AuthContextType {
  accessToken: string | null;
  userId: string | null;
  setAccessToken: (token: string | null) => void;
  setUserId: (userId: string | null) => void;
}

export const AuthContext = createContext<AuthContextType>({
  accessToken: null,
  userId: null,
  setAccessToken: () => {},
  setUserId: () => {},
});

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [accessToken, setAccessToken] = useState<string | null>(localStorage.getItem('accessToken'));
  const [userId, setUserId] = useState<string | null>(localStorage.getItem('userId'));

  // Re-link analytics/monitoring identity for an already-authenticated user on boot.
  useEffect(() => {
    const id = localStorage.getItem('userId');
    if (id) {
      const role = localStorage.getItem('userRole');
      identifyUser(id, { role });
      setMonitoringUser({ id, role });
    }
  }, []);

  return (
    <AuthContext.Provider value={{ accessToken, userId, setAccessToken, setUserId }}>
      {children}
    </AuthContext.Provider>
  );
};